import * as CryptoJS from 'crypto-js'
// Define your encryption key
let ENCRYPTION_KEY = import.meta.env.VITE_JWT_SECRET ?? 'XY+MRHHzb0+EPSHo1pkasg=='

// Function to encrypt data
export const encryptData = (data) => {
  if (typeof data === 'string' && data.trim() === '') return ''
  if (Array.isArray(data) && data.length === 0) return []
  const dataToEncrypt = typeof data === 'string' ? data : JSON.stringify(data)

  try {
    const encryptedData = CryptoJS.AES.encrypt(dataToEncrypt, ENCRYPTION_KEY).toString()
    // console.log('Encrypted Data:', encryptedData);  // Log the encrypted data
    return encryptedData
  } catch (err) {
    console.error('Error during encryption:', err)
    return '' // Return empty string on error
  }
}
